import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiPolicy } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiPolicyDialogData {
  policies?: ApiPolicy[];
}

@Component({
  selector: 'app-multi-policy-dialog',
  templateUrl: './multi-policy-dialog.component.html',
  styleUrls: ['./multi-policy-dialog.component.css'],
  standalone: false,
})
export class MultiPolicyDialogComponent implements OnInit {

  //プライバシーポリシー×言語数
  policies: ApiPolicy[] = [];
  policiesFormGroup!: FormGroup;
  policiesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiPolicyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiPolicyDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.policies = this.data.policies!;
    if (!this.policies) {
      this.policies = [];
    }
    this.createForm();
    this.policiesArrayControl = this.policiesFormGroup.get('policies') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.policiesFormGroup.disable();
    }
  }

  //プライバシーポリシーフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.policies.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let policy = '';
      let trans_policy = '';
      for (const value of this.policies) {
        if (!value.auto_trans && index !== 0) {
          isAutoAllTrans = false;
        }
        auto_trans = value.auto_trans ? value.auto_trans : false;
      if (projectLanguage.lang_code === value.lang_code) {
          policy = value.policy;
          trans_policy = value.trans_policy;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          policy: [policy],
          transPolicy: [trans_policy],
        }
      ));
      index++;
    }
    this.policiesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        policies: arrayControl
      }
    );
  }

  //更新ボタン
  addPolicies(): void {
    if (this.policiesFormGroup.valid) {
      let policies = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.policiesArrayControl.controls[index];
        policies.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            policy: ctrl.get('policy')!.value,
            trans_policy: ctrl.get('transPolicy')!.value,
          }
        )
      }
      this.policies = policies;
      this.dialogRef.close(this.policies);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.policiesFormGroup.get('autoAllTrans')!.value;
    for (const policy of this.policiesArrayControl.controls) {
      policy.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.policiesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const policy of this.policiesArrayControl.controls) {
      if (!policy.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.policiesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
